class ProductForm extends HTMLElement {
  connectedCallback() {
    this.form = this.querySelector('form');
    this.selects = [...this.querySelectorAll('[data-option-select]')];
    this.variants = JSON.parse(this.querySelector('[data-variants]').textContent);
    this.currency = this.dataset.currency || 'USD';
    this.selects.forEach((select, index) => select.addEventListener('change', () => this.updateVariant(index)));
    this.updateVariant();
  }

  updateVariant(changedIndex) {
    const selected = this.selects.map((select) => select.value);
    let variant = this.variants.find((item) => item.available && item.options.every((option, index) => option === selected[index]));
    if (!variant && changedIndex !== undefined) {
      variant = this.variants.find((item) => item.available && item.options[changedIndex] === selected[changedIndex]);
      if (variant) this.selects.forEach((select, index) => { select.value = variant.options[index]; });
    }
    this.selects.forEach((select, optionIndex) => {
      [...select.options].forEach((option) => {
        option.disabled = !this.variants.some((item) => item.available && item.options[optionIndex] === option.value);
      });
    });
    const id = this.querySelector('[name="id"]');
    const button = this.querySelector('[name="add"]');
    const price = this.querySelector('[data-product-price]');
    if (!variant) {
      id.value = '';
      button.disabled = true;
      button.textContent = 'Unavailable';
      return;
    }
    id.value = variant.id;
    price.textContent = new Intl.NumberFormat(undefined, { style: 'currency', currency: this.currency }).format(variant.price / 100);
    button.disabled = !variant.available;
    button.textContent = variant.available ? 'Add to cart' : 'Sold out';
    const section = this.closest('[data-product-section]') || document;
    section.querySelectorAll('[data-sticky-variant-id]').forEach((input) => { input.value = variant.id; });
    section.querySelectorAll('[data-sticky-price]').forEach((item) => { item.textContent = price.textContent; });
    section.querySelectorAll('[data-sticky-variant-title]').forEach((item) => { item.textContent = variant.title; });
    section.querySelectorAll('[data-sticky-add-button]').forEach((item) => {
      item.disabled = !variant.available;
      item.textContent = variant.available ? 'Add to cart' : 'Sold out';
    });
  }
}
customElements.define('product-form', ProductForm);

class MediaGallery extends HTMLElement {
  connectedCallback() {
    this.querySelectorAll('[data-media-thumb]').forEach((thumb) => thumb.addEventListener('click', () => {
      this.querySelectorAll('[data-media]').forEach((media) => { media.hidden = media.dataset.media !== thumb.dataset.mediaThumb; });
      this.querySelectorAll('[data-media-thumb]').forEach((item) => item.classList.toggle('is-active', item === thumb));
    }));
  }
}
customElements.define('media-gallery', MediaGallery);

function initSliders(scope = document) {
scope.querySelectorAll('[data-slider]:not([data-initialized])').forEach((slider) => {
  slider.dataset.initialized = 'true';
  const track = slider.querySelector('[data-slider-track]');
  const slides = [...track.children];
  const dots = [...slider.querySelectorAll('[data-slider-dot]')];
  let index = 0;
  const show = (next) => {
    index = (next + slides.length) % slides.length;
    track.style.transform = `translateX(-${index * 100}%)`;
    dots.forEach((dot, dotIndex) => dot.classList.toggle('is-active', dotIndex === index));
  };
  slider.querySelector('[data-slider-prev]')?.addEventListener('click', () => show(index - 1));
  slider.querySelector('[data-slider-next]')?.addEventListener('click', () => show(index + 1));
  dots.forEach((dot) => dot.addEventListener('click', () => show(Number(dot.dataset.sliderDot))));
  show(0);
  if (slides.length > 1) setInterval(() => show(index + 1), Number(slider.dataset.autoplay) || 5000);
});
}

function initDrawer(scope = document) {
  const drawer = document.querySelector('[data-mobile-drawer]');
  const overlay = document.querySelector('.drawer-overlay');
  const opener = scope.querySelector('[data-drawer-open]:not([data-initialized])');
  if (opener) {
    opener.dataset.initialized = 'true';
    opener.addEventListener('click', () => {
    drawer.hidden = false;
    overlay.hidden = false;
    });
  }
  scope.querySelectorAll('[data-drawer-close]:not([data-initialized])').forEach((button) => {
    button.dataset.initialized = 'true';
    button.addEventListener('click', () => {
      drawer.hidden = true;
      overlay.hidden = true;
    });
  });
}

function initSearchPopover(scope = document) {
  const popover = document.querySelector('[data-search-popover]');
  if (!popover) return;
  scope.querySelectorAll('[data-search-open]:not([data-initialized])').forEach((button) => {
    button.dataset.initialized = 'true';
    button.addEventListener('click', () => {
      popover.hidden = false;
      popover.querySelector('input[type="search"]')?.focus();
    });
  });
  scope.querySelectorAll('[data-search-close]:not([data-initialized])').forEach((button) => {
    button.dataset.initialized = 'true';
    button.addEventListener('click', () => {
      popover.hidden = true;
    });
  });
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') popover.hidden = true;
  });
}

function initCountdowns(scope = document) {
scope.querySelectorAll('[data-countdown]:not([data-initialized])').forEach((countdown) => {
  countdown.dataset.initialized = 'true';
  const storageKey = `flash-sale-${countdown.dataset.countdownId}`;
  const configuredEnd = Date.parse(countdown.dataset.endDate);
  const storedEnd = Number(sessionStorage.getItem(storageKey));
  let end = Number.isFinite(configuredEnd) && configuredEnd > Date.now() ? configuredEnd : storedEnd;
  if (!Number.isFinite(end) || end <= Date.now()) {
    end = Date.now() + (Number(countdown.dataset.fallbackHours) || 24) * 3600000;
    sessionStorage.setItem(storageKey, String(end));
  }
  const update = () => {
    const remaining = Math.max(0, end - Date.now());
    const values = {
      days: Math.floor(remaining / 86400000),
      hours: Math.floor((remaining / 3600000) % 24),
      minutes: Math.floor((remaining / 60000) % 60),
      seconds: Math.floor((remaining / 1000) % 60)
    };
    Object.entries(values).forEach(([key, value]) => { countdown.querySelector(`[data-${key}]`).textContent = String(value).padStart(2, '0'); });
  };
  update();
  setInterval(update, 1000);
});
}

initSliders();
initDrawer();
initCountdowns();
initSearchPopover();
document.querySelectorAll('[data-quantity-input]').forEach((input) => {
  input.addEventListener('input', () => {
    const section = input.closest('[data-product-section]') || document;
    section.querySelectorAll('[data-sticky-quantity]').forEach((stickyInput) => { stickyInput.value = input.value || '1'; });
  });
});
document.querySelectorAll('[data-localization-select]').forEach((select) => {
  select.addEventListener('change', () => select.form.submit());
});
document.addEventListener('shopify:section:load', (event) => {
  initSliders(event.target);
  initDrawer(event.target);
  initCountdowns(event.target);
  initSearchPopover(event.target);
});
